import { Car } from "../../../types/Car/Car.interface";
import { CarSelection } from "./CarSelection/CarSelection";
import { CurrentCar } from "./CurrentCar/CurrentCar";
import { useAppSelector, RootState } from "@/utils/storage/stores/store";

export const ChoiceCar = () => {
    const selectedCar: Car | null = useAppSelector((state: RootState) => state.user.car);
    const isShownCarSelection: boolean = useAppSelector((state: RootState) => state.user.isShownCarSelection);

    return (
        <>
            {selectedCar && isShownCarSelection && <CurrentCar/>}
            {!selectedCar && isShownCarSelection && <CarSelection/>}
        </>
    );
};